import React, {useEffect, useState} from 'react';
import getProfileInitials from '../utils/getProfileInitials.js';

// Kolecko s profilovou fotkou nebo iniciálami, jen na zobrazení.
// Narozdíl od EditableProfilePhoto nerenderuje žádné popupy ani nereaguje na klik,
// takže se dá použít i v hustých seznamech (rezervace na home) a klik projde na rodiče.
// initials: kdyz displayName neni "Jmeno Prijmeni" (napr. rezervace posilaji jen prezdivku),
// da se predat hotovy dvoupismenny zkratek. Jinak se dopocita z displayName jako jinde.
export default function UserAvatar({photoUrl = '', displayName = '', initials = '', className = '', title = ''}) {
	const [imageLoadError, setImageLoadError] = useState(false);

	useEffect(() => {
		setImageLoadError(false);
	}, [photoUrl]);

	const showPhotoImage = photoUrl !== '' && !imageLoadError;
	const resolvedInitials = initials !== '' ? initials : getProfileInitials(displayName);

	return (
		<span className={`user-avatar${className !== '' ? ` ${className}` : ''}`} title={title !== '' ? title : displayName}>
			{showPhotoImage ? (
				<img className="user-avatar__image" src={photoUrl} alt="" onError={() => setImageLoadError(true)} />
			) : (
				<span className="user-avatar__initials">{resolvedInitials}</span>
			)}
		</span>
	);
}
